export default "__VITE_ASSET__Cebwo9Rd__"